import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import { StyledGlobalCss } from '@service-victoria/component-library/utils/globalStyles';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Use GlobalStyles from StyledGlobalCss from sv-component-library */
  ${StyledGlobalCss}

  body {
    @media ${device.isDesktop} {
      background-color: ${colors.blueGrey10};
    }
  }

  // note: Extra specificity so that it overrides the component library BG color
  div#root {
    @media ${device.isMobile}, ${device.isTablet} {
      background-color: colors.white;
    }
  }
  .ReactModalPortal {
    z-index: 10000;
    position: relative;
  }
`;

export default GlobalStyle;
